import { render, staticRenderFns } from "./ConfirmCard.vue?vue&type=template&id=06a4e62b&scoped=true"
import script from "./ConfirmCard.vue?vue&type=script&lang=js"
export * from "./ConfirmCard.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCard.vue?vue&type=style&index=0&id=06a4e62b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4e62b",
  null
  
)

export default component.exports